import { Observable } from 'rxjs';

import { TpvMemphisOperator } from '@app/domain/models/tpv/memphis-operator.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';
import { TpvReportFile, TpvReportFormat } from '@app/domain/models/tpv/tpv-report.model';

/**
 * Filtros del listado/reporte de operadores Memphis (`GET /operadores/`).
 * El scope lo aplica el backend (operadores de comercios accesibles).
 */
export interface MemphisOperatorListFilters {
  /** Búsqueda parcial por nombre completo o correo. */
  search?: string;
  name?: string;
  email?: string;
  active?: boolean;
  idUserMemphis?: number;
  page?: number;
  limit?: number;
}

/**
 * Port de operadores Memphis (usersTDM) — las personas que operan las terminales.
 * Distinto del gestor/operador Polipay. Solo lectura + reporte.
 */
export abstract class MemphisOperatorRepository {
  /** Listado paginado (`GET /operadores/`). */
  abstract listOperators(
    filters?: MemphisOperatorListFilters,
  ): Observable<TpvPage<TpvMemphisOperator>>;

  /** Reporte descargable (`GET /operadores/report/`). */
  abstract getOperatorsReport(
    format: TpvReportFormat,
    filters: Omit<MemphisOperatorListFilters, 'page' | 'limit'>,
  ): Observable<TpvReportFile>;
}
